import React from 'react';
import Footer from '../components/Footer';

const DisclaimerPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <div className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-8">Platform Disclaimer</h1>

                    <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                        <p className="lead text-lg mb-6">
                            Please read this disclaimer carefully before using the Harshal Jobs platform.
                        </p>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. No Responsibility for Job Offers</h2>
                            <p>
                                Harshal Jobs acts solely as a facilitator connecting job seekers and employers. We do not guarantee the authenticity,
                                validity, or existence of any job opening listed on our platform. While we strive to verify employers,
                                Harshal Jobs is not responsible for any job offers, terms of employment, or the conduct of any employer.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Financial Disclaimer</h2>
                            <p>
                                Harshal Jobs will <strong>never</strong> ask job seekers for money to schedule interviews, process applications,
                                or secure job offers. We strictly advise all users to never pay any fees to employers or third parties claiming to represent Harshal Jobs for job placement. Harshal Jobs is not liable for any financial loss incurred by users
                                resulting from such fraudulent activities.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Anti-Fraud Warning</h2>
                            <p>
                                We are committed to maintaining a safe platform, but we cannot control the actions of every user.
                                Harshal Jobs explicitly disclaims any liability for fraud, scams, or deceptive practices by third parties
                                using this platform. Users are advised to exercise caution and due diligence when interacting with others
                                and to report any suspicious activity to our support team immediately.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Limitation of Liability</h2>
                            <p>
                                Under no circumstances shall Harshal Jobs, its affiliates, directors, employees, or agents be liable for any
                                direct, indirect, incidental, special, or consequential damages arising from your use of this platform,
                                including but not limited to damages for loss of profits, goodwill, use, data, or other intangible losses.
                            </p>
                        </section>

                        <div className="pt-8 mt-8 border-t border-gray-200">
                            <p className="text-sm text-gray-500">
                                If you encounter any suspicious activity, please contact us immediately at <a href="mailto:support@harshaljobs.com" className="text-blue-600 hover:text-blue-800">support@harshaljobs.com</a>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default DisclaimerPolicy;
